import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import { AppellateMasterData } from "types/models/appellateMaster/AppellateMasterApp";

const StyledTableCell = styled(TableCell)(() => ({
  fontSize: 14,
  padding: 8,
  minWidth: 150,
  maxWidth: 150,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  "&:first-of-type": {
    paddingLeft: 20,
  },
  "&:last-of-type": {
    paddingRight: 20,
  },
}));

interface TableItemProps {
  data: AppellateMasterData;
}

const TableItem: React.FC<TableItemProps> = ({ data }) => {
  return (
    <TableRow key={data.id} className="item-hover">
      <StyledTableCell>{data.createdAt}</StyledTableCell>
      <StyledTableCell>{data.customerId}</StyledTableCell>
      <StyledTableCell>{data.ticketId}</StyledTableCell>
      <StyledTableCell title={data.message}>{data.message}</StyledTableCell>
      <StyledTableCell>{data.source}</StyledTableCell>
      <StyledTableCell>{data.reference}</StyledTableCell>
      <StyledTableCell>{data.name}</StyledTableCell>
      <StyledTableCell>{data.mobile}</StyledTableCell>
      <StyledTableCell>{data.email}</StyledTableCell>
    </TableRow>
  );
};

export default TableItem;
